/**
 * useSearchPaginationStore
 */

import { useCallback } from 'react';
import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';

const { useApolloClient } = ApolloLib;
const { GET_PAGE } = Queries;

const useSearchPaginationStore = () => {

    const client = useApolloClient();

    const { page } = client.readQuery({ query: GET_PAGE });

    const setPage = useCallback((page) => {

        client.writeQuery({
            query: GET_PAGE,
            data: { page },
        });

    }, [client]);

    return {
        page,
        setPage,
    };

};

export default useSearchPaginationStore;
